
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/march-madness-matchups",
      function () {
        return require("private-next-pages/march-madness-matchups/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/march-madness-matchups"])
      });
    }
  